import type { TupleToUnion, ValueOf } from 'type-fest'

export enum MimeTypeCategory {
    IMAGE = 'image',
    DOCUMENT = 'document'
}

export const MIME_TYPES = {
    image: [
        'image/png',
        'image/jpeg',
        'image/webp'
    ],
    document: [
        'application/pdf'
    ],

    getCategory(value: string): MimeTypeCategory | null {
        if (this.image.includes(value as TupleToUnion<ValueOf<typeof this.image>>)) return MimeTypeCategory.IMAGE
        if (this.document.includes(value as TupleToUnion<ValueOf<typeof this.document>>)) return MimeTypeCategory.DOCUMENT

        return null
    }
} as const

export type MimeType = TupleToUnion<ValueOf<typeof MIME_TYPES>>
